import styles from "../Paragraph.module.css";

/**
 * HtmlText — wrapper dla treści HTML akapitu (text / text_1 / text_2).
 *
 * **Trust source:** content pochodzi z panelu admina Imperial — admin może
 * wstawić HTML (np. `<a>`, `<strong>`, listy, tabele) i jest to expected
 * feature, nie XSS. Backend (`IPARAGRAPH_CONTROLLER::parseVariables`) podmienia
 * jeszcze `{DOMAIN}` / `{YEAR}` placeholders przed wysłaniem.
 *
 * **Empty handling:** gdy text jest null/empty/whitespace — komponent nic nie
 * renderuje (zwraca `null`). Pozwala konsumentowi nie sprawdzać sam.
 */
export function HtmlText({
  html,
  className,
}: {
  html: string | null | undefined;
  className?: string;
}) {
  if (!html || typeof html !== "string" || html.trim() === "") return null;
  return (
    <div
      className={`${styles.htmlText} ${className ?? ""}`}
      dangerouslySetInnerHTML={{ __html: sanitizeTableStyles(html) }}
    />
  );
}

/**
 * TinyMCE table dialog wpisuje inline `style="border-collapse: collapse"` na `<table>`;
 * `border-collapse: collapse` IGNORUJE `border-radius` (spec), a `:where(table)` w CSS
 * ma specificity 0 - nie pobije inline style. Stripujemy tylko tę jedną deklarację,
 * zeby CSS `border-collapse: separate` mogl wejsc; reszta inline stylow (kolor ramki
 * z Table Properties, width, itd.) zostaje nietknięta.
 */
function sanitizeTableStyles(html: string): string {
  return html.replace(/(<table\b[^>]*\sstyle=")([^"]*)(")/gi, (_, pre, style: string, post) => {
    const cleaned = style
      .replace(/\bborder-collapse\s*:\s*[^;]+;?/gi, "")
      .replace(/\s{2,}/g, " ")
      .trim();
    return `${pre}${cleaned}${post}`;
  });
}
